import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		terrain: "Plat",
		architecture: "Simple",
		surface: 100,
		surface_sous_sol: 0,
		finition: "Clés en main",
		garage: "Non",
		carport: "Non",
		nom: "",
		prenom: "",
		adresse: "",
		cp: "",
		ville: "",
		email: "",
		telephone: "",
		possedeterrain: "Acquis",
		accompagnement: "",
		acceptance: true,
		fourchette_estimative: 0,
		pdf: "",
		mainTimer: 0
	},
	mutations: {
		setTerrain(state, payload) {
			this.state.terrain = payload;
		},
		setArchitecture(state, payload) {
			this.state.architecture = payload;
		},
		setSurface(state, payload) {
			this.state.surface = payload;
		},
		setSousSol(state, payload) {
			this.state.surface_sous_sol = payload;
		},
		setFinition(state, payload) {
			this.state.finition = payload;
		},
		setGarage(state, payload) {
			this.state.garage = payload;
		},
		setCarPort(state, payload) {
			this.state.carport = payload;
		},
		setFourchette(state, payload) {
			this.state.fourchette_estimative = payload;
		},
		setPdf(state, payload) {
			this.state.pdf = payload;
		},
		setTimer(state, payload) {
			this.state.mainTimer = payload;
		},
		setCoordonnees(state, payload) {
			this.state.nom = payload.nom;
			this.state.prenom = payload.prenom;
			this.state.adresse = payload.adresse;
			this.state.cp = payload.cp;
			this.state.ville = payload.ville;
			this.state.email = payload.email;
			this.state.telephone = payload.telephone;
			this.state.possedeterrain = payload.possedeterrain;
			this.state.accompagnement = payload.accompagnement;
			this.state.acceptance = payload.acceptance;
		},
		resetState(state) {
			this.state.terrain = "Plat";
			this.state.architecture = "Simple";
			this.state.surface = 100;
			this.state.surface_sous_sol = 0;
			this.state.finition = "Clés en main";
			this.state.garage = "Non";
			this.state.carport = "Non";
			this.state.nom = "";
			this.state.prenom = "";
			this.state.adresse = "";
			this.state.cp = "";
			this.state.ville = "";
			this.state.email = "";
			this.state.telephone = "";
			this.state.possedeterrain = "Acquis";
			this.state.accompagnement = "";
			this.state.acceptance = true;
			this.state.fourchette_estimative = 0;
			this.state.pdf = "";
		}
	},
	actions: {}
});
